<template>
    <div class="col-12">
      <div class="card-body px-0 pb-2">
        <div class="p-4">
          <form @submit.prevent="handleSubmit" @keydown.enter.prevent>
            <div class="row g-3">
           ئ
  
              <div class="col-md-6">
                <label for="subject_id" class="bmd-label-float">المادة</label>
                <select
                  class="form-control borderless-input"
                  :class="{ 'is-invalid': errors.subject_id }"
                  id="subject_id"
                  v-model="formData.subject_id"
                  required
                  @blur="validateField('subject_id')"
                >
                  <option value="" disabled>اختر المادة</option>
                  <option 
                    v-for="subject in subjects" 
                    :key="subject.id" 
                    :value="subject.id"
                  >
                    {{ subject.name }}
                  </option>
                </select>
                <div class="invalid-feedback">{{ errors.subject_id }}</div>
              </div>
  
              <div class="col-md-6">
                <label for="status" class="bmd-label-float">الحالة</label>
                <select
                  class="form-control borderless-input"
                  :class="{ 'is-invalid': errors.status }"
                  id="status"
                  v-model="formData.status"
                  required
                >
                  <option value="active">نشط</option>
                  <option value="inactive">غير نشط</option>
                </select>
                <div class="invalid-feedback">{{ errors.status }}</div>
              </div>
  
              <div class="col-12">
                <div class="d-flex gap-3 mt-3">
                  <button
                    type="submit"
                    class="btn btn-primary btn-sm flex-grow-1"
                    :disabled="loading"
                  >
                    <span v-if="loading">
                      <i class="fas fa-spinner fa-spin ms-2"></i>
                      جاري الحفظ...
                    </span>
                    <span v-else>
                      <i class="fas fa-save ms-2"></i>
                      {{ submitText || "حفظ التغييرات" }}
                    </span>
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary btn-sm flex-grow-1"
                    @click="handleCancel"
                    :disabled="loading"
                  >
                    <i class="fas fa-times ms-2"></i>
                    إلغاء
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, watch, defineEmits, defineProps } from "vue";
  import { useToast } from "vue-toastification";
  import api from "@/api";
  
  const props = defineProps({
    title: String,
    submitText: {
      type: String,
      default: "حفظ"
    },
    loading: {
      type: Boolean,
      default: false
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    initialData: {
      type: Object,
      default: () => ({
        chapter_id: "",
        subject_id: "",
        status: "active"
      })
    }
  });
  
  const emit = defineEmits(['submit', 'cancel', 'validation-error']);
  const toast = useToast();
  
  const formData = ref({ ...props.initialData });
  const chapters = ref([]);
  const subjects = ref([]);
  const errors = ref({});
  
  onMounted(async () => {
    try {
      const [chaptersRes, subjectsRes] = await Promise.all([
        api.get('/chapters'),
        api.get('/subjects')
      ]);
      chapters.value = chaptersRes.data.data;
      subjects.value = subjectsRes.data.data;
    } catch (error) {
      toast.error("فشل في تحميل البيانات");
      console.error("Error fetching data:", error);
    }
  });
  
  const validateField = (field) => {
    if (!formData.value[field]) {
      errors.value[field] = "هذا الحقل مطلوب";
      return false;
    }
    delete errors.value[field];
    return true;
  };
  
  const validateForm = () => {
    errors.value = {};
    const validations = [
      validateField('chapter_id'),
      validateField('subject_id'),
      validateField('status')
    ];
  
    return validations.every(valid => valid);
  };
  
  const handleSubmit = () => {
    if (!validateForm()) {
      emit('validation-error');
      toast.warning("الرجاء تصحيح الأخطاء في النموذج");
      return;
    }
    emit('submit', formData.value);
  };
  
  const handleCancel = () => {
    emit('cancel');
  };
  
  watch(() => props.initialData, (newData) => {
    formData.value = { ...newData };
  }, { immediate: true, deep: true });
  </script>